import React, { Component } from 'react';
import { Grid } from 'react-bootstrap';
import {
  userConfirmation,
  USER_CONFIRMATION_SUCCESS
} from '../redux/modules/auth';
import { connect } from 'react-redux';
import i18n from 'kodyl-js/i18n/react';
import { addAlert } from '../redux/modules/app';
import { browserHistory } from 'react-router';
import ErrorMessage from '../common/error-message';

@connect(
  () => ({}),
  { userConfirmation, addAlert }
)
@i18n
class Verify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false
    };
  }

  componentWillMount() {
    if (__CLIENT__) {
      const { userConfirmation, location, addAlert } = this.props;
      return userConfirmation(location.query).then(action => {
        if (action.error) {
          this.setState({ error: true });
          return action;
        }
        if (action.type === USER_CONFIRMATION_SUCCESS) {
          if (action.payload.subscriptions.length) {
            addAlert({
              style: 'success',
              text: this.i18n('Your %s is now active', 'bruger'),
              views: 1
            });
            browserHistory.replace('/profile/tenant');
            return action;
          }
          addAlert({
            style: 'success',
            text: this.i18n('Your %s is now active', 'bruger'),
            views: 1
          });
          browserHistory.replace('/profile/subscription');
          return action;
        }
        return action;
      });
    }
  }

  errMsg() {
    return (
      <Grid>
        <ErrorMessage
          text={this.i18n(
            'We could not recognize you verification token. Make sure you type in the full address.'
          )}
        />
      </Grid>
    );
  }

  render() {
    const { error } = this.state;
    if (error) {
      return this.errMsg();
    }
    return (
      <Grid>
        <h3>{this.i18n('Et øjeblik. Vi henter lige din bruger...')}</h3>
      </Grid>
    );
  }
}

export default Verify;
